module.exports = __webpack_public_path__ + "static/SöhneBreit-BuchKursiv-f3f0b6c2057d4af2227952a4f1a3c754.otf";